import type { FC } from "react";
import { useState } from "react";
import { Popover } from "react-tiny-popover";

export type PopOverProps = {
	isOpen?: boolean;
	visible?: boolean;
	content: FC<any> | any;
	children: FC<any> | any;
};

export const PopOver = (props: PopOverProps) => {
	const [isOpen, setOpen] = useState(props.isOpen || false);

	const shouldBeVisible = props.visible ?? isOpen;

	const openPopOver = () => {
		setOpen(true);
	};

	const closePopOver = () => {
		setOpen(false);
	};

	const togglePopOver = () => {
		setOpen(!isOpen);
	};

	return (
		<Popover
			isOpen={shouldBeVisible}
			positions={["bottom"]}
			align={"end"}
			reposition
			onClickOutside={() => closePopOver()}
			content={(e) => (
				<>
					{/* <motion.div {...animationProps}>
                        <AnimatePresence> */}
					{typeof props.content === "function"
						? props.content({
								closePopOver,
								openPopOver,
								togglePopOver,
								...e,
							})
						: props.content}
					{/* </AnimatePresence>
                    </motion.div> */}
				</>
			)}
			containerClassName="z-popover"
		>
			{typeof props.children === "function"
				? props.children({
						openPopOver,
						closePopOver,
						togglePopOver,
					})
				: props.children}
		</Popover>
	);
};
